module.exports = __webpack_public_path__ + "static/media/55_000011.d1efe77a.jpg";